import { createContext, useContext } from "react";
import type { SettingsDestination } from "./directory";

/**
 * The settings directory, for the cards that hold a namespace and nothing else.
 *
 * An approval card for a configuration change carries namespace keys -- that is
 * what the tool call contains -- and the page drawing it has to say 「涉及：模型
 * 连接、确认规则」 rather than print them. It used to look those names up in a
 * table of nineteen written into the shell (D380). This is the same answer from
 * the declarations, passed down rather than threaded through eight call sites of
 * a card that is drawn on seven pages.
 *
 * The default is empty, and every reader degrades to saying how many settings
 * are involved instead of which: a tree that has not read the panels yet knows
 * the count and does not know the names, and that is the honest sentence.
 */
export const SettingsDirectory = createContext<SettingsDestination[]>([]);

export function useSettingsDirectory(): SettingsDestination[] {
  return useContext(SettingsDirectory);
}
